module.exports = __webpack_public_path__ + "static/media/gabi.8b9d0695.jpg";